import { useQuery } from '@tanstack/react-query';

import { getCustomerCount } from '@arrived/api_v2';
import { CustomerCount } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { customerCountKey } from './kpis.keys';

export function useGetCustomerCountQuery(options?: UseQueryOptions<CustomerCount>) {
  return useQuery(customerCountKey, getCustomerCount, { ...options, staleTime: options?.staleTime ?? MAX_STALE_TIME });
}
